import {Chips} from 'platform/components';

import {isNotNil} from 'ramda';

import type {Locale} from '@dms/api/base';
import i18n from '@dms/i18n';

export const ALL_LOCALES_VALUE = 'all' as const;

export type LocaleChipValue = Locale | typeof ALL_LOCALES_VALUE;

interface LocaleFilterChipsProps {
  value: LocaleChipValue;
  onChange: (next: LocaleChipValue) => void;
  supportedLocales: {value: Locale; label: string}[];
}

export function LocaleFilterChips(props: LocaleFilterChipsProps) {
  const options = [
    {value: ALL_LOCALES_VALUE, label: i18n.t('general.labels.allLocales')},
    ...props.supportedLocales,
  ];

  const isLocaleChipValue = (candidate: string): candidate is LocaleChipValue =>
    candidate === ALL_LOCALES_VALUE ||
    props.supportedLocales.some((entry) => entry.value === candidate);

  return (
    <Chips
      value={[props.value]}
      options={options}
      onChange={(next) => {
        const picked = next?.[0];
        if (isNotNil(picked) && isLocaleChipValue(picked)) {
          props.onChange(picked);
        }
      }}
      data-testid="document-templates-locale-filter"
    />
  );
}
